import { Trash2 } from "lucide-react";
import type { FC, ReactNode } from "react";

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: ReactNode;
  confirmLabel?: string;
  isPending?: boolean;
  onConfirm: () => void;
};

/** Destructive confirmation; stays open while the delete is in flight. */
export const ConfirmDeleteDialog: FC<Props> = ({
  open,
  onOpenChange,
  title,
  description = "This action cannot be undone.",
  confirmLabel = "Delete",
  isPending = false,
  onConfirm
}) => (
  <AlertDialog
    open={open}
    onOpenChange={(next) => {
      if (!next && isPending) return;
      onOpenChange(next);
    }}
  >
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{title}</AlertDialogTitle>
        <AlertDialogDescription>{description}</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel disabled={isPending}>Cancel</AlertDialogCancel>
        <Button variant="destructive" disabled={isPending} onClick={onConfirm}>
          <Trash2 className="size-3.5" />
          {isPending ? "Deleting…" : confirmLabel}
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
